


























































































































































import { v4 as uuidv4 } from 'uuid';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';

@Component({
  name: 'bulk-move-to-trash-modal',
  components: {},
})
export default class BulkMoveToTrashModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'bulk-move-to-trash' })
  readonly modalId: string;
  @Prop({ type: String, default: null }) readonly entityName: string;
  @Prop({ type: Object, default: null }) readonly filters: object;
  @Prop({ type: Object, default: null })
  readonly searchAndOrder: SearchAndOrder;
  // NOTE: by default allowProcessAll is true to have retrocompatibility with the previous version
  // ideally allowProcessAll should be false and specify only those places where we want to have
  // the option to process all activated (Main entitytables only probably)
  @Prop({ type: Boolean, default: true }) readonly allowProcessAll: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedEntities: string[];
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly dataToShow: [string[]];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly extraData: object;

  // Data
  public moveToTrashEventsError: object[] = [];
  public moveToTrashEventsSuccess: object[] = [];
  public moveToTrashRequestSent: boolean = false;
  public isMovingToTrash: boolean = false;
  public reportPerPage: number = 20;
  public reportCurrentPage: number = 1;
  public processAll: boolean = false;
  public showGlobalError: boolean = false;
  public globalErrorMessage: string = '';

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Computed
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
  get title() {
    return this.$t('global.modals.bulk-soft-delete.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get body() {
    return this.$t('global.modals.bulk-soft-delete.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get reportRows() {
    return this.moveToTrashEventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.moveToTrashEventsError.slice(start, end);
  }

  // Methods
  openModal(): void {
    this.resetModal();
    this.$bvModal.show(this.modalId);
  }
  closeModal(): void {
    this.resetModal();
    this.$bvModal.hide(this.modalId);
  }
  resetModal(): void {
    this.moveToTrashEventsError = [];
    this.moveToTrashEventsSuccess = [];
    this.moveToTrashRequestSent = false;
    this.isMovingToTrash = false;
    // NOTE important to reset this value otherwise the next time the modal
    // is opened it will be potentially true
    this.processAll = false;
  }
  onConfirmMoveToTrash(): void {
    const basePath = this.$bpcApiRouteHelper.getEntityPath(this.entityName);
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketMoveToTrashChannel(sessionCode);
    this.moveToTrashRequestSent = true;

    this.$bpcApi
      .post(basePath + '/bulk-delete', {
        entities: this.selectedEntities,
        filters: this.filters,
        search_and_order: this.searchAndOrder,
        process_all: this.allowProcessAll && this.processAll,
        session_code: sessionCode,
        total_entities: this.totalEntities,
        ...this.extraData,
      })
      .subscribe(
        res => {
          this.$emit('request-sent');
        },
        error => {
          this.$emit('error-sending-request');
          this.$bpcEcho.leaveMoveToTrashChannel(sessionCode);
          this.resetModal();
        },
      );
  }
  getSessionCode(): string {
    return `move-to-trash-${this.tenantId}-${uuidv4()}`;
  }
  listenToWebsocketMoveToTrashChannel(sessionCode): void {
    this.isMovingToTrash = true;
    this.$bpcEcho
      .listenMoveToTrashChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\EntitiesTrashed', data => {
        this.$bpcMessage.showInfoMessage({
          text: 'global.actions.bulk_move_to_trash.entities_trashed',
        });
        this.isMovingToTrash = false;
        this.$emit('trashed');
        this.$bpcEcho.leaveMoveToTrashChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\GlobalMoveToTrashError', data => {
        this.$bpcMessage.showErrorMessage({
          text: 'global.actions.bulk_move_to_trash.something_went_wrong',
        });
        this.isMovingToTrash = false;
        this.showGlobalError = true;
        this.globalErrorMessage = this.$t(data.reason) as string;
        this.$emit('trashed');
        this.$bpcEcho.leaveMoveToTrashChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\EntityMovedToTrash', data => {
        this.moveToTrashEventsSuccess.push(data);
      })
      .listen('.BPC\\Core\\Events\\ErrorMovingEntityToTrash', data => {
        this.moveToTrashEventsError.push(data);
      });
  }
  onCloseModal(): void {
    this.$emit('on-close-modal');
  }

  // Watchers
  @Watch('showModal')
  onChangeShowModal(val) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
